import React from 'react';

const Email = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.8672 3.33325H3.53385C2.61719 3.33325 1.87552 4.08325 1.87552 4.99992L1.86719 14.9999C1.86719 15.9166 2.61719 16.6666 3.53385 16.6666H16.8672C17.7839 16.6666 18.5339 15.9166 18.5339 14.9999V4.99992C18.5339 4.08325 17.7839 3.33325 16.8672 3.33325ZM16.8672 6.66659L10.2005 10.8333L3.53385 6.66659V4.99992L10.2005 9.16659L16.8672 4.99992V6.66659Z" fill="white"/>
  </svg>
);

export default Email;